var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"app"}},[_c('Navbar'),_c('section',{staticClass:"hold-view"},[_c('router-view')],1),_c('Footer'),(_vm.loadingPageData == true)?_c('LoadingDataFetch'):_vm._e()],1)
}
var staticRenderFns = []

export { render, staticRenderFns }